// @flow
import styles from './StickyHeader.less';
import React from 'react';
import { get } from 'lodash';

import Sticky from 'react-sticky-el';

import { Section, Hidden, PageBlock, Text } from 'seek-style-guide/react';

import JobTitle from '../JobTitle/JobTitle';
import MoreJobsLink from '../MoreJobsLink/MoreJobsLink';

const getTopOffset = branding => {
  const rowHeight = 6;
  const stickyHeaderHeight = rowHeight * 11;
  const applyButtonHeight = rowHeight * 8;

  const fixedButtonOffset = (stickyHeaderHeight - applyButtonHeight) / 2;
  const blockButtonSpacing = rowHeight * 3;

  const defaultStickyOffset = blockButtonSpacing - fixedButtonOffset;

  if (get(branding, 'cover.url')) {
    const coverImageHeight = 65;
    const coverImageOverlay = 20;
    const coverImageOffset = (coverImageHeight - coverImageOverlay) * rowHeight;
    return coverImageOffset + defaultStickyOffset;
  }

  if (branding) {
    const logoHeightDesktop = 23;
    const logoOnlyOffset = logoHeightDesktop * rowHeight;
    return logoOnlyOffset + defaultStickyOffset;
  }

  return defaultStickyOffset;
};

const StickyHeader = ({
  title,
  isExpired,
  advertiser,
  branding,
  isPrivateAdvertiser
}: ChaliceJobDetail) => (
  <Hidden print mobile>
    <Sticky
      topOffset={getTopOffset(branding)}
      stickyClassName={styles.whenSticky}
    >
      <div className={styles.stickyHeader}>
        <PageBlock>
          <section aria-labelledby="jobHeader" aria-hidden="true">
            <Section className={styles.section}>
              <Text strong small data-automation="job-detail-title">
                <JobTitle
                  component="h2"
                  isExpired={isExpired}
                  title={title}
                  className={styles.truncate}
                />
              </Text>
              {isPrivateAdvertiser ? (
                <Text small>{advertiser.description}</Text>
              ) : (
                <MoreJobsLink
                  small
                  className={styles.truncate}
                  advertiser={advertiser}
                  analytics="job-details-more-jobs-sticky-clicked"
                  data-automation="job-details-header-more-jobs"
                />
              )}
            </Section>
          </section>
        </PageBlock>
      </div>
    </Sticky>
  </Hidden>
);

export default StickyHeader;
